import { Component, EventEmitter, Input, Output } from '@angular/core';

import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { ProfileResponse } from '@smarthead-api/models/profile-response';

import { RouterLinkCreatorService } from '../../../../services/router-link-creator.service';
import { MainNavService } from '../../services/main-nav.service';

@Component({
  selector: 'sh-main-nav-profiles-mobile',
  templateUrl: './main-nav-profiles-mobile.component.html',
  styleUrl: './main-nav-profiles-mobile.component.scss',
  standalone: false
})
export class MainNavProfilesMobileComponent {
  @Input() profiles: ProfileResponse[] = [];
  @Output() closeMenu = new EventEmitter();

  itemClassList$: Observable<string[]>;

  constructor(
    private routerLinkCreatorService: RouterLinkCreatorService,
    private mainNavService: MainNavService
  ) {
    this.itemClassList$ = this.mainNavService.activeUrl$.pipe(map(activeUrl => (activeUrl === 'profile' ? ['active'] : [])));
  }

  profileLink(profile: ProfileResponse) {
    return this.routerLinkCreatorService.createProfileLink(profile.id, profile.title, false, 'ADMIN-DASHBOARD');
  }

  navigateToCreateProfile() {
    this.routerLinkCreatorService.navigateToCreateProfile();
  }

  onCloseMenu() {
    this.closeMenu.emit();
  }
}
